// import Vue from 'vue'
import axios from "axios";

// WebSocket 재연결/세션체크용 모듈 전역 상태(단일 스토어 사용 전제)
let wsReconnectTimer = null;
let wsManualClose = false;

// 비동기 로직
export default {
  async login({ state, commit }, payload) {
    // let failFlag = false
    let userInfo = null;
    // LDAP LOGIN
    await axios
      .post(
        "/ldap/login",
        { input: { user_id: payload.userId, user_pw: payload.password } },
        { timeout: 1000 }
      )
      .then(async (response) => {
        if (response.data.Output.resultCode === 0) {
          userInfo = response.data.Output.userInfo;
          let pwPeriod = await axios.post("/ldap/periodCheck", {
            input: { user_id: payload.userId, user_pw: payload.password },
          });
          if (pwPeriod.data.Output.resultCode === 0) {
          } else {
            alert(pwPeriod.data.Output.resultMessage);
          }
          // 비밀번호 만료 경고 메세지
          // if (response.data.Output.resultMessage.includes('3개월')) {
          //   alert(response.data.Output.resultMessage)
          // }
        } else {
          if (payload.userId === "admin") {
            let localRes = await axios.post("/user/login", {
              input: { user_id: payload.userId, user_pw: payload.password },
            });
            // console.log(localRes)
            if (localRes.data.Output.resultCode === 0) {
              userInfo = localRes.data.Output.userInfo;
            } else {
              state.userInfo.loginYn = false;
            }
          } else {
            state.userInfo.loginYn = false;
            if (response.data.Output.resultMessage.includes("기본인증")) {
              await axios
                .post("/user/pwdErrCntUp", {
                  input: { user_id: payload.userId },
                })
                .then(function (response) {
                  commit("setErrorCnt", response.data.Output.error_cnt);
                });
            }
          }
        }
      })
      .catch(async (error) => {
        var errMsg = error.toString();
        if (errMsg.includes("timeout")) {
          console.log("timeout error");
        } else {
          console.log("catch error : " + error);
        }
        // Ldap 로그인 실패 -> 로컬 로그인
        let localRes = await axios.post("/user/login", {
          input: { user_id: payload.userId, user_pw: payload.password },
        });
        if (localRes.data.Output.resultCode === 0) {
          userInfo = localRes.data.Output.userInfo;
        } else {
          commit("setErrorCnt", localRes.data.Output.error_cnt);
          state.userInfo.loginYn = false;
        }
      });
    // console.log(userInfo)
    if (userInfo) {
      // 재로그인 시 이전 WS 수동종료 플래그/타이머를 초기화
      wsManualClose = false;
      if (wsReconnectTimer) {
        clearTimeout(wsReconnectTimer);
        wsReconnectTimer = null;
      }
      var param = {
        loginYn: true,
        id: payload.userId,
        name: userInfo.user_nm,
        scope: userInfo.scope,
        authority: userInfo.authority,
        stateCd: userInfo.state_cd,
        headquarter: userInfo.region,
        errorCnt: userInfo.error_cnt,
      };
      commit("setUserInfo", param);
    }
  },
  async logout({ state, commit }) {
    wsManualClose = true;
    if (wsReconnectTimer) {
      clearTimeout(wsReconnectTimer);
      wsReconnectTimer = null;
    }
    try {
      if (state.webSocket) {
        state.webSocket.onclose = null;
        state.webSocket.close();
      }
    } catch (e) {
      // ignore
    }

    await axios
    .post("/comn/logout", {})
    .catch(async (error) => {
      var errMsg = error.toString();
      if (errMsg.includes("401")) {
        commit("setUserInfo");
        window.location.hash = "#/login";
      }
    });
  },
  async websockConn({ state, commit, dispatch }) {
    if (!state.userInfo || !state.userInfo.loginYn || !state.userInfo.id) return;
    if (wsManualClose) {
      wsManualClose = false;
      if (wsReconnectTimer) {
        clearTimeout(wsReconnectTimer);
        wsReconnectTimer = null;
      }
    }

    if (
      state.webSocket !== null &&
      state.webSocket.readyState === WebSocket.OPEN
    ) {
      return;
    }

    let url = window.location.host;
    let checkDevPort = window.location.port;
    if (checkDevPort == "9020") {
      url = window.location.hostname + ":" + 8080;
    }
    let protocol = window.location.protocol.startsWith("https") ? "wss" : "ws";

    let webSocketUrl = protocol + "://" + url + "/its/webSocketServer";
    state.webSocket = new WebSocket(webSocketUrl);

    state.webSocket.onopen = (message) => {
      console.log("WebSocket Server connected: ", message);
      wsManualClose = false;
      if (wsReconnectTimer) {
        clearTimeout(wsReconnectTimer);
        wsReconnectTimer = null;
      }
    };
    state.webSocket.onclose = async (message) => {
      console.log("WebSocket Server Disconnected: ", message);
      if (wsManualClose) return;
      if (!state.userInfo || !state.userInfo.loginYn || !state.userInfo.id) return;

      if (wsReconnectTimer) return;
      wsReconnectTimer = setTimeout(() => {
        wsReconnectTimer = null;
        dispatch("websockConn");
      }, 5000);
    };
    state.webSocket.onerror = (message) => {
      console.error("WebSocket Server error: ", message);
    };
    state.webSocket.onmessage = (message) => {
      if (message) {
        state.centerBus.$emit(
          "webSocketServerMessage",
          JSON.parse(message.data)
        );
      }
    };
  },
};



// WEBPACK FOOTER //
// ./src/vuex/actions.js